// 项目"作品语言"(content_language)支持集 — 与后端 internal/llm.LanguageNames 对齐。
// 注意: 这是"内容生成语言", 与 UI 显示语言(i18n locale, 仅 zh/en)是两个独立维度。
// display 用各语言母语名(native name), 让作者一眼认出自己的语言。

export interface ContentLanguageOption {
  code: string
  /** 母语显示名, 如 日本語 / Français */
  native: string
}

export const CONTENT_LANGUAGES: ContentLanguageOption[] = [
  { code: 'zh', native: '中文' },
  { code: 'en', native: 'English' },
  { code: 'ja', native: '日本語' },
  { code: 'ko', native: '한국어' },
  { code: 'fr', native: 'Français' },
  { code: 'de', native: 'Deutsch' },
  { code: 'es', native: 'Español' },
  { code: 'it', native: 'Italiano' },
  { code: 'ru', native: 'Русский' },
  { code: 'pt', native: 'Português' },
  { code: 'ar', native: 'العربية' },
  { code: 'th', native: 'ไทย' },
  { code: 'vi', native: 'Tiếng Việt' },
  { code: 'id', native: 'Bahasa Indonesia' },
]

const CONTENT_LANGUAGE_CODES = new Set(CONTENT_LANGUAGES.map((l) => l.code))

/** UI locale → 默认作品语言: 命中支持集则用之, 否则回退 zh。 */
export function defaultContentLanguage(uiLocale?: string): string {
  if (uiLocale && CONTENT_LANGUAGE_CODES.has(uiLocale)) return uiLocale
  return 'zh'
}

/** 取母语显示名, 未知码回退为码本身。 */
export function contentLanguageNative(code?: string): string {
  if (!code) return ''
  return CONTENT_LANGUAGES.find((l) => l.code === code)?.native ?? code
}
